/**
 * Signal Archive client — read-only public endpoints.
 * Zero side effects, zero AI calls (backend enforced).
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

const request = async (path) => {
  const r = await fetch(`${API_BASE}${path}`, { credentials: "include" });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
};

export const signalsArchive = ({
  q, country, source, sector, freshness,
  dateFrom, dateTo,
  sort = "added_desc", limit = 20, offset = 0,
} = {}) => {
  const params = new URLSearchParams();
  if (q)         params.set("q", q);
  if (country)   params.set("country", country);
  if (source)    params.set("source", source);
  if (sector)    params.set("sector", sector);
  if (freshness) params.set("freshness", freshness);
  if (dateFrom)  params.set("date_from", dateFrom);
  if (dateTo)    params.set("date_to", dateTo);
  if (sort)      params.set("sort", sort);
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  return request(`/api/signals/archive?${params.toString()}`);
};

export const signalsFilters = () => request("/api/signals/filters");
export const signalDetail   = (id) => request(`/api/signals/${encodeURIComponent(id)}`);
